<div [formGroup]="form" [hidden]="isHidden" class="control-container">
    <se-floating-label
        [class.invisible]="!control.isWithLabel"
        [for]="control.id"
        [state]="formControl?.invalid ? 'error' : isDisabled ? 'disabled' : 'active'"
        [tooltip]="control.name"
    >
        {{ control.name }}
    </se-floating-label>

    <div *ngIf="editorConfig$ | async; let config" prosemirror-stop [style.height]="config.height">
        <se-smart-text-editor
            name="control.id"
            style="height: 100%"
            [debounceTime]="300"
            [suggestionList]="config.suggestions"
            [id]="control.id"
            [isInError]="formControl?.invalid"
            [formControlName]="control.id"
            [predefinedMenuConfiguration]="config.menu"
            [title]="config.title"
            [visible]="isVisible$ | async"
            [visibilityButtonEnabled]="config.isToggleEnabled"
            [lightLayout]="lightLayout"
            [defaultTextName]="control.defaultText?.defaultTextName"
            (visibilityNotify)="onVisibilityChange($event)"
            (isEmpty)="onIsEmptyChange($event)"
            (startSpeechReconition)="onStartSpeechReconition($event)"
            (selectedSuggestion)="onSelectedSuggestion($event)"
        >
            <ng-container extra-buttons-before>
                <cp-additional-content
                    *ngFor="let additionalContent of control.additionalContent"
                    [control]="additionalContent"
                    [cardId]="cardId"
                    [disabled]="isDisabled"
                ></cp-additional-content>
            </ng-container>
        </se-smart-text-editor>
    </div>
</div>
